/* Facets Drawer — open/close + auto-submit sort */
const FACETS_CHAT_SELECTORS = [
  '#shopify-chat',
  '#shopify-chat-app',
  '#chat-widget-container',
  '.shopify-chat',
  'iframe[id^="chat"]',
  'iframe[name^="chat"]',
].join(',');

class FacetsDrawer extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('[data-facets-close]').forEach((el) =>
      el.addEventListener('click', () => this.close())
    );
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.classList.contains('is-open')) this.close();
    });
  }
  toggleChat(hide) {
    document.querySelectorAll(FACETS_CHAT_SELECTORS).forEach((el) => {
      el.style.visibility = hide ? 'hidden' : '';
      el.style.pointerEvents = hide ? 'none' : '';
    });
  }
  open() {
    this.classList.add('is-open');
    this.setAttribute('aria-hidden', 'false');
    document.body.classList.add('facets-drawer-open');
    this.toggleChat(true);
  }
  close() {
    this.classList.remove('is-open');
    this.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('facets-drawer-open');
    this.toggleChat(false);
  }
}
if (!customElements.get('facets-drawer')) customElements.define('facets-drawer', FacetsDrawer);

document.addEventListener('click', (e) => {
  const opener = e.target.closest('[data-facets-open]');
  if (!opener) return;
  const drawer = document.querySelector('facets-drawer');
  if (!drawer) return;
  e.preventDefault();
  drawer.open();
});

// Auto-submit sort form
document.addEventListener('change', (e) => {
  const sortForm = e.target.closest('[data-sort-form]');
  if (!sortForm) return;
  const url = new URL(window.location.href);
  url.searchParams.set('sort_by', sortForm.querySelector('select').value);
  window.location.href = url.toString();
});

// Apply filters — build a clean URL (drop empty values, keep current sort)
document.addEventListener('submit', (e) => {
  const form = e.target.closest('[data-facets-form]');
  if (!form) return;
  e.preventDefault();

  const base = form.getAttribute('action') || window.location.pathname;
  const url = new URL(base, window.location.origin);

  // Preserve the active sort, which lives outside this form.
  const currentSort = new URL(window.location.href).searchParams.get('sort_by');
  if (currentSort) url.searchParams.set('sort_by', currentSort);

  new FormData(form).forEach((value, key) => {
    if (value !== null && String(value).trim() !== '') {
      url.searchParams.append(key, value);
    }
  });

  window.location.href = url.toString();
});
